<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/signin"></ion-back-button>
    </ion-buttons>
    <ion-title>Reset Password</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <ion-grid>
    <ion-row>
      <ion-col>
        <ion-img
          src="../../../assets/images/MimboLogo.png"
          class="logo"
        ></ion-img>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
        <ion-list>
          <ion-item lines="none" class="ion-text-center" color="lightmimbo">
            <ion-text class="prompt"
              >Kindly enter the email for the account you want to
              reset</ion-text
            >
          </ion-item>
          <ion-item color="lightmimbo">
            <ion-label position="floating">E-Mail</ion-label>
            <ion-input
              name="email"
              #email
              required
              [readonly]="showOTP"
              [ngClass]="{'readonly': showOTP}"
            ></ion-input>
          </ion-item>
          <ion-item color="lightmimbo" *ngIf="showOTP">
            <ion-label position="floating">OTP</ion-label>
            <ion-input name="OTP" [(ngModel)]="OTP" required></ion-input>
          </ion-item>
        </ion-list>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-button color="primary" (click)="sendOTP(email)" *ngIf="!showOTP"
          >Reset Password
          <ion-icon slot="start" name="refresh-circle-outline"></ion-icon
        ></ion-button>
        <ion-button
          color="primary"
          (click)="resetPassword(email)"
          *ngIf="showOTP"
          style="width: 165px"
          >Confirm OTP <ion-icon slot="start" name="save-outline"></ion-icon
        ></ion-button>
      </ion-col>
    </ion-row>
    <ion-row class="ion-text-center">
      <ion-col>
        <ion-button color="primary" (click)="changeEmail()" *ngIf="showOTP"
          >Change Email <ion-icon slot="start" name="save-outline"></ion-icon
        ></ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
